import { Component, ElementRef, HostListener, OnDestroy, OnInit, Output, ViewChild, PLATFORM_ID, Input, EventEmitter, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Location, isPlatformBrowser, NgIf, NgFor, NgClass, TitleCasePipe, CurrencyPipe, NgOptimizedImage, SlicePipe, UpperCasePipe } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';

//* Redux
import { AppStateCart } from '../../../state/cart/cart.reducer';
import { Store } from '@ngrx/store';
import * as cart from '../../../state/cart/cart.actions';
import * as user from '../../../state/user/user.actions';
import { AppStateUser } from 'src/app/state/user/user.reducer';
import { Subject } from 'rxjs';

//* 3rd
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

//* Material
import { MatMenuTrigger, MatMenuModule } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';

//* Components
import { WarnMissingProductsComponent } from './../warn-missing-products/warn-missing-products.component';
import { NotNearStoresModalComponent } from './../not-near-stores-modal/not-near-stores-modal.component';
import { AccessibilitySettingsComponent } from 'src/app/profile/my-profile/accessibility-settings/accessibility-settings.component';
import { AddressAddComponent } from 'src/app/profile/addresses/address-add/address-add.component';
import { DeliveryComponent } from '../delivery/delivery.component';
import { SigninComponent } from '../signin/signin.component';
import { CartComponent } from '../cart/cart.component';
import { UserDataIncompletedComponent } from '../user-data-incompleted/user-data-incompleted.component';
import { CpInviteModeModalComponent } from '../cp-invite-mode-modal/cp-invite-mode-modal.component';
import { AddCardComponent } from 'src/app/club/add-card/add-card.component';
import { RedeemComponent } from 'src/app/purchase/redeem/redeem.component';

//* Models
import { Item } from '@models/cart.model';
import { IAlsuperTypes, IGetNearStoresRequest, NearStore, NearStoresData, NullableIAlsuperTypes } from '@models/store.model';
import { IClient } from '@models/client.model';
import { CostumerData } from '@models/user.model';
import { EventCustomData, PixelEvent } from '@models/pixel.model';

//* Services
import { OrderService } from '@services/order.service';
import { ClubService } from '@services/club.service';
import { AddressObserverService } from '@services/address-observer.service';
import { CartObserverService } from '@services/cart-observer.service';
import { SnackbarService } from '@services/snackbar.service';
import { ProductsService } from '@services/products.service';
import { AddressService } from '@services/address.service';
import { StoreService } from '@services/stores.service';
import { CartService } from '@services/cart.service';
import { AuthService } from '@services/auth.service';
import { TokenService } from '@services/token.service';
import { LocalstorageService } from '@services/localstorage.service';
import { ProductsValidationsService } from '@services/products-validations.service';
import { MarketingService } from '@services/marketing.service';

//* Shared
import { ACTIONS_TOOLBAR, AVATAR_DEFAULT, AVATAR_LIST, MENU_LIST } from '@shared/utils';
import { imageHandling } from '@shared/imageHandling';
import { encryptTextSHA256 } from '@shared/encryptText';
import { TranslateModule } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { Department } from '@models/departments.model';
import { DepartmentService } from '@services/department.service';
import { MobileMenuModalComponent } from '../mobile-menu-modal/mobile-menu-modal.component';


//* Pixels
declare let gtag: any;
declare let pintrk: Function;
declare let fbq: Function;

@Component({
  selector: 'app-home-toolbar',
  templateUrl: './home-toolbar.component.html',
  styleUrls: ['./home-toolbar.component.scss'],
  standalone: true,
  imports: [NgIf, MatToolbarModule, RouterLink, MatIconModule, SlicePipe, UpperCasePipe, MatButtonModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, LottieComponent, NgFor, NgClass, MatMenuModule, MatProgressSpinnerModule, MatTooltipModule, MatBadgeModule, TitleCasePipe, CurrencyPipe, TranslateModule, MatSnackBarModule, NgOptimizedImage]
})
export class HomeToolbarComponent implements OnInit, OnDestroy {

  public selectedStore: { displayName: string; store: number; type: string; zipCode: string; };
  @Output() openSidenav = new EventEmitter();
  @Input() sizeAdjustment: boolean;
  public appStoreUrl = environment.appStore;
  public googlePlayUrl = environment.googlePlay;
  public urlStore: string;
  public user: CostumerData | null;
  public address: any;
  public latitude: any;
  public cart: any = [];
  public longitude: any;
  public totalItems = 0;
  public totalAmount = 0;
  public isMobile = false;
  public nearStore: NearStore | null;
  public deliveryType = true;
  public selectedAddress: any;
  public menuList = MENU_LIST;
  private subs = new Subject<void>();
  public displayLoader = false;
  public addresses: any[] = [];
  public shouldDisplay = false;
  public avatar = AVATAR_DEFAULT;
  public actions = ACTIONS_TOOLBAR;
  public alsuperTypes: NullableIAlsuperTypes[] = [];
  public displayAlsuperTypes = false;
  public allProductsResult: any[] = [];
  public mainProductsResult: any[] = [];
  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };
  private reloadCartSubject = new Subject();
  public addressesLoading = true;
  public searchForm = new UntypedFormGroup({
    keyword: new UntypedFormControl('')
  });
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (this.isBrowser) this.isMobile = window.innerWidth <= 800;
  }
  @ViewChild('results', { static: false }) resultRef: ElementRef;
  @ViewChild('deliveryMenuTrigger') deliveryMenuTrigger: MatMenuTrigger;
  @ViewChild('storeTypeMenuTrigger') storeTypeMenuTrigger: MatMenuTrigger;
  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.resultRef.nativeElement.contains(event.target)) {
      this.shouldDisplay = false;
    }
  }
  public deleteSpaceTop = false;
  public storeId: number;
  public token: string;
  public card_owner: string;
  public clubAmmount: number;
  public avatarLoading = true;
  public nearStoresServiceResponse: NearStoresData;
  public showBlack = false;
  public isLoggedIn: boolean;
  public client: IClient;
  public productImage: string;
  public clubCardAmount: string;
  public sharedCard: boolean;

  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);

  private defaultStore = environment.defaultStore;
  public departments: Department[] = [];

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private location: Location,
    private authService: AuthService,
    private cartService: CartService,
    private storeServices: StoreService,
    private addressService: AddressService,
    private productService: ProductsService,
    private snackbarService: SnackbarService,
    private cartObserver: CartObserverService,
    private addressObserver: AddressObserverService,
    private clubService: ClubService,
    private ordersService: OrderService,
    private tokenService: TokenService,
    private store: Store<AppStateCart>,
    private storeUser: Store<AppStateUser>,
    private localStorageService: LocalstorageService,
    private productsValidationsService: ProductsValidationsService,
    private marketingService: MarketingService,
    private departmentService: DepartmentService
  ) {
    if (this.isBrowser) {
      this.storeId = JSON.parse(localStorage.getItem('address') || '{}').store;
      this.token = JSON.parse(localStorage.getItem('token') || '{}').jwt;
      router.events.pipe(takeUntil(this.subs)).subscribe(() => {
        this.showBlack = (this.location.path().includes('al-asador'));
      });
    }
  }

  ngOnInit(): void {
    this.getDepartments();
    this.clubService.reloadClubAlsuper$.pipe(takeUntil(this.subs)).subscribe(({
      next: (reload: boolean) => {
        if (reload) {
          this.getCurrentUser();
        }
      }
    }));
    this.authService.refreshAuth$.pipe(takeUntil(this.subs)).subscribe(({
      next: async (response: boolean) => {
        if (response) {
          this.store.dispatch(cart.unSetCart());
          this.storeUser.dispatch(user.unSetUser());
          if (this.isBrowser) localStorage.clear();
          await this.authService.signout();
          this.tokenService.signOut();
          await this.router.navigate(['/autenticacion/iniciar-sesion']);
          this.toValidateToken();
          this.totalItems = 0;
          this.totalAmount = 0;
          this.user = null;
          this.ordersService.refreshHome$.emit(true);
        }
      }
    }));
    this.cartObserver.dataUser.pipe(takeUntil(this.subs)).subscribe((counter: number) => this.totalItems = counter);
    this.searchForm.get('keyword')?.valueChanges.pipe(
      debounceTime(400),
      takeUntil(this.subs)
    )
      .subscribe(
        () => {
          this.onSearching();
        }
      );
    this.toValidateToken();
    this.observerInit();
    this.getClientData();
  }

  ngOnDestroy(): void {
    this.subs.next();
    this.subs.complete();
  }

  public getDepartments(): void {
    if (this.isBrowser) {
      const storeId = JSON.parse(localStorage.getItem('address') || '{}').store;
      this.departmentService.getDepartments(storeId ?? this.defaultStore).pipe(take(1)).subscribe(({
        next: ({ data }) => {
          this.departments = data.map((department: Department) => {
            department.show = false;
            const nameArr = department.description.split(' ');
            const desc = nameArr.join('-');
            department.department_url = `departamento/${desc.toLowerCase()}-${department.department_id}`;
            return department;
          });
        }
      }));
    }
  }


  private reloadCartObseverDebounce(): void {
    this.reloadCartSubject.pipe(
      debounceTime(200)
    ).subscribe(async (data) => {
      this.getCart();
    });
  }

  private reloadCartObsever(): void {
    this.cartObserver.cart$.pipe(takeUntil(this.subs)).subscribe(async (reload: any) => {
      if (reload) {
        this.reloadCartSubject.next(null);
      }
    });
  }




  public observerInit(): void {
    this.reloadCartObsever();
    this.reloadCartObseverDebounce();
    if (this.isBrowser) this.selectedStore = JSON.parse(localStorage.getItem('address') || '{}');

    this.addressObserver.address$.pipe(takeUntil(this.subs)).subscribe(async (response: any) => {
      if (response.status) {
        if (response.pickup) {
          this.toValidateToken();
        } else {
          this.deliveryType = true;
        }
        this.deliveryMenuTrigger.openMenu();
        await this.getAddresses();
      }
    });
    this.authService.avatar$.pipe(takeUntil(this.subs)).subscribe((res: boolean) => {
      if (res) {
        this.getCurrentUser();
      }
    });
  }

  public getClientData(): void {
    this.storeUser.select('user').pipe(takeUntil(this.subs)).subscribe(({ data }) => {
      this.client = data;
    });
  }

  private async getNearStores(): Promise<void> {
    if (this.address) {
      const addressData: IGetNearStoresRequest = {
        coordinates: {
          lat: this.latitude,
          lng: this.longitude
        }
      };
      this.nearStore = null;
      try {
        const { data } = await this.storeServices.getStoresByCoordsPolygon(addressData);
        this.nearStoresServiceResponse = data;
        this.alsuperTypes[0] = this.nearStoresServiceResponse.ALSUPER === null ? null : { value: data.ALSUPER.name, image: 'ic-alsuper-blue', filter: 'alsuper' };
        this.alsuperTypes[1] = this.nearStoresServiceResponse.ALSUPER_PLUS === null ? null : { value: data.ALSUPER_PLUS.name, image: 'ic-alsuper-red', filter: 'alsuper_plus' };
        this.alsuperTypes[2] = this.nearStoresServiceResponse.FRESH_MARKET === null ? null : { value: data.FRESH_MARKET.name, image: 'ic-alsuper-green', filter: 'fresh_market' };
      } catch (error) { }
    }
  }

  public async toValidateToken(): Promise<void> {
    if (this.isBrowser) {
      this.isMobile = window.innerWidth <= 800;
      const tokenAux = localStorage.getItem('token');
      if (tokenAux) {
        this.getCurrentUser();
        if (!localStorage.getItem('address')) {
          this.onSelectingDelivery();
        }
        this.getAddresses();
        this.getCart();
      } else {
        if (window.location.pathname === '/') {
          this.onDisplayLoginDialog();
        }
      }
      const localAux = JSON.parse(localStorage.getItem('address') || '{}');
      this.selectedAddress = localAux ?? '';
      if (this.selectedAddress) {
        this.deliveryType = this.selectedAddress.type === 'delivery' ? true : false;
      }
    }
  }

  public onHomeNavigation(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
  }

  public onOpen(): void {
    this.openSidenav.emit();
  }

  public toSignin(): void {
    this.router.navigate(['/autenticacion/iniciar-sesion']);
  }

  private async getCurrentUser(): Promise<void> {
    this.avatarLoading = true;
    try {
      const user$ = await this.authService.getCurrentUser();
      this.store.dispatch(user.setUser({ data: user$.data[0] }));
      this.user = user$.data[0];
      if (this.user?.avatar) {
        AVATAR_LIST.forEach(avatar => {
          if (avatar.id === this.user?.avatar) {
            this.avatar = avatar;
          }
        });
      }
      this.avatarLoading = false;

      if (this.user.membership) {
        await this.getAlsuperPoints();
      } else {
        this.card_owner = '';
        this.clubAmmount = 0;
        this.clubCardAmount = '';
        this.sharedCard = false;
      }

      if (!this.user?.gender || !this.user?.date_birth) {
        this.dialog.open(UserDataIncompletedComponent, {
          autoFocus: false,
          disableClose: true
        });
      }
    } catch (error) {
      if (error instanceof HttpErrorResponse) {
        if (this.user?.avatar) {
          AVATAR_LIST.forEach(avatar => {
            if (avatar.id === this.user?.avatar) {
              this.avatar = avatar;
            }
          });
        }
      }
      this.avatarLoading = false;
    }
  }

  private async getAlsuperPoints(): Promise<void> {
    if (this.user) {
      try {
        const { data } = await this.clubService.getClubPointsByNumber(this.user.membership);
        const [membershipData] = data.membership_data;
        if (membershipData) {
          this.card_owner = membershipData.Mensaje;
          this.clubAmmount = membershipData.Saldo;
          this.clubCardAmount = data.message;
          this.sharedCard = data.shared;
        }
      } catch (error) { }
    }
  }

  public onActivatingClubCard(): void {
    this.dialog.open(AddCardComponent, {
      panelClass: 'as-activate-club',
      autoFocus: false
    });
  }

  public alsuperCardDialog(): void {
    this.dialog.open(RedeemComponent, {
      maxWidth: '80vw',
      autoFocus: false,
      data: { hideButton: true }
    });
  }

  public checkIfExistsClubAlsuperCard(): void {
    !this.card_owner && !this.clubAmmount && !this.clubCardAmount ? this.onActivatingClubCard() : this.alsuperCardDialog();
  }

  public async getAddresses(): Promise<any> {
    this.addresses = [];
    try {
      const { data } = await this.addressService.getAddresses();
      this.addresses = data;
      this.addressesLoading = false;
      this.addresses.forEach(async (address: any) => {
        if (address.default) {
          this.address = address;
          this.latitude = address.coordinates[0];
          this.longitude = address.coordinates[1];
          let res: any;
          if (isPlatformBrowser(this.platformId)) {
            res = JSON.parse(localStorage.getItem('address') || '{}');
          }
          switch (res.type) {
            case 'pickup':
              await this.cartService.onSettingPickupAddress({
                branch_id: res.store
              });
              break;
            case 'delivery':
              await this.cartService.onSettingDeliveryAddress({
                branch_id: res.store,
                client_address: this.address.id
              });
              break;
            default:
              break;
          }
        }
      });
      await this.getNearStores();
    } catch (error) {
      this.addressesLoading = false;
    }
  }

  private getCart(): void {
    this.cart = [];
    this.totalItems = 0;

    // Subscribe to the cartService.onGettingCartList() observable
    this.cartService.onGettingCartList().subscribe({
      next: ({ data }) => {
        if (data) {
          this.cart = data;
          const counter = this.productsValidationsService.setCartCounter(data.items);
          this.cartObserver.setdatauser(counter);
          this.totalAmount = data.total;
          this.store.dispatch(cart.setCart({ info: data }));
          const tempItems = data.items.map((item: Item) => ({ ...item }));
          this.localStorageService.setProperty('cartItems', tempItems);
        }
      }
    });
  }

  public delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public onSelectingDelivery(): void {
    this.dialog.open(DeliveryComponent, {
      panelClass: 'as-delivery-dialog'
    }).afterClosed().subscribe(async response => {
      if (response.status) {
        if (response.pickup) {
          this.toValidateToken();
        } else {
          this.deliveryType = true;
        }
        //  this.observerInit();
        this.deliveryMenuTrigger.openMenu();
        this.ordersService.refreshHome$.emit(true);
        await this.getAddresses();
      }
    });
  }

  public onDisplayLoginDialog(): void {
    this.dialog.open(SigninComponent, {
      autoFocus: false
    }).afterClosed().subscribe((res: boolean) => {
      if (res === false && !this.selectedStore.displayName) {
        this.openCpSelect();
      }
    });
  }

  public onClickChangeType(): void {
    this.displayAlsuperTypes = false;
    if (this.deliveryType) {
      this.storeTypeMenuTrigger.closeMenu();
    }
    if (!this.deliveryType) {
      this.dialog.open(DeliveryComponent, {
        panelClass: 'as-delivery-dialog'
      }).afterClosed().subscribe(async response => {
        if (response.status) {
          if (!response.pickup) {
            this.deliveryType = !this.deliveryType;
          } else {
            this.toValidateToken();
          }
          //  this.observerInit();
          this.deliveryMenuTrigger.openMenu();
          this.ordersService.refreshHome$.emit(true);
          await this.getAddresses();
        }
      });
    }
  }

  public onChangeDeliveryType(): void {
    this.deliveryType = !this.deliveryType;
    if (!this.deliveryType) {
      this.deliveryMenuTrigger.closeMenu();
      this.dialog.open(DeliveryComponent, {
        panelClass: 'as-delivery-dialog',
        data: {
          pickup: true,
          coords: { lat: this.address.coordinates[0], lng: this.address.coordinates[1] },
          address: this.address
        }
      }).afterClosed().subscribe(response => {
        if (response.status) {
          if (!response.pickup) {
            this.deliveryType = !this.deliveryType;
          } else {
            this.toValidateToken();
          }
          //  this.observerInit();
          this.deliveryMenuTrigger.openMenu();
          this.ordersService.refreshHome$.emit(true);
        } else {
          this.deliveryType = !this.deliveryType;
        }
      });
    }
  }

  public async onSelectingAddress(address: any, $event: any): Promise<any> {
    $event.stopPropagation();
    this.address = address;
    this.latitude = address.coordinates[0];
    this.longitude = address.coordinates[1];
    await this.getNearStores();
    this.displayAlsuperTypes = true;
  }

  public async onNavigate(route: string): Promise<void> {
    switch (route) {
      case 'signout':
        if (isPlatformBrowser(this.platformId)) {
          this.store.dispatch(cart.unSetCart());
          this.storeUser.dispatch(user.unSetUser());
          localStorage.clear();
        }
        await this.authService.signout();
        this.tokenService.signOut();
        await this.router.navigate(['']);
        this.toValidateToken();
        //  this.observerInit();
        this.totalItems = 0;
        this.totalAmount = 0;
        this.user = null;
        this.ordersService.refreshHome$.emit(true);
        break;
      case 'preferences':
        this.dialog.open(AccessibilitySettingsComponent, {}).afterClosed().subscribe((response) => {
          if (response) {
            this.snackbarService.openSnackbar('MYPROFILE.updatedPreferences', 'success');
          }
        });
        break;
      case 'listas-alsuper':
        if (this.user) {
          this.router.navigate([route]);
          if (isPlatformBrowser(this.platformId)) {
            window.scroll(0, 0);
          }
        } else {
          this.dialog.open(SigninComponent, {});
        }
        break;
      default:
        if (isPlatformBrowser(this.platformId)) {
          window.scroll(0, 0);
        }
        break;
    }
  }

  public onDisplayCart(): void {
    this.dialog.open(CartComponent, {
      panelClass: ['as-cart-dialog', 'animate__animated', 'animate__slideInRight'],
      hasBackdrop: true,
      autoFocus: false,
      width: this.isMobile ? '100vw' : 'auto',
      height: this.isMobile ? '100vh' : 'auto',
      maxWidth: this.isMobile ? '100vw' : 'auto',
      position: { right: 'right' },
    });
  }

  public onSearching(): void {
    this.mainProductsResult = [];
    if (this.isBrowser) this.storeId = JSON.parse(localStorage.getItem('address') || '{}').store;

    const searchData = {
      keyword: this.searchForm.get('keyword')?.value,
      store_id: this.storeId,
      limit: 3
    };

    if (this.searchForm.get('keyword')?.value !== '' && this.searchForm.get('keyword')?.value?.length > 3) {
      this.shouldDisplay = true;
      this.displayLoader = true;

      // Subscribe to the productService.searchProducts() observable
      this.productService.searchProducts(searchData).subscribe({
        next: (products: any) => {
          if (products.data.data !== 'emptyArray') {
            this.allProductsResult = products.data.data;

            this.allProductsResult.forEach((product: any) => {
              product.price = Number.parseFloat(product.price);
              product.regular_price = Number.parseFloat(product.regular_price);
              if (product.image_url) {
                const imgHa = imageHandling(product.image_url, 'small', '.webp');
                product.image_url = imgHa;
              }
              if (this.isMobile) {
                if (this.mainProductsResult.length < 7) {
                  this.mainProductsResult.push(product);
                  this.shouldDisplay = true;
                }
              } else {
                if (this.mainProductsResult.length < 3) {
                  product.discount = 100 - Math.trunc((product.price * 100) / product.regular_price);
                  this.mainProductsResult.push(product);
                  this.shouldDisplay = true;
                }
              }
            });

            this.mainProductsResult.forEach((item: any) => {
              const descriptionArr = item.short_description.split(' ');
              const desc = descriptionArr.join('-');
              const arrWithoutSlash = desc.split('/');
              item.product_url = `producto/${arrWithoutSlash.join('-').toLowerCase()}-${item.id}`;
            });

            if (isPlatformBrowser(this.platformId)) {
              gtag('event', 'view_item_list', {
                items: this.mainProductsResult.map((product: any, index: number) => ({
                  list_name: 'Products Search',
                  id: product.id.toString(),
                  name: product.name,
                  variant: product.variant ?? '',
                  quantity: product.quantity,
                  list_position: index,
                  price: product.price,
                  category: product.category_name,
                  brand: product.department
                }))
              });
            }

            this.displayLoader = false;
          } else {
            this.displayLoader = false;
          }
        },
        error: () => {
          this.displayLoader = false;
        }
      });
    } else {
      this.displayLoader = false;
      this.shouldDisplay = false;
    }
  }

  public cleanSearch(): void {
    this.searchForm.reset();
    this.shouldDisplay = false;
    this.mainProductsResult = [];
  }

  public async onClickProduct(name: string, id: string): Promise<void> {
    const descriptionArr = name.split(' ');
    const desc = descriptionArr.join('-');
    const arrWithoutSlash = desc.split('/');
    await this.router.navigate([`producto/${arrWithoutSlash.join('-').toLowerCase()}-${id}`]);
    this.cleanSearch();
  }

  public suggestProduct(keyword: string): void {
    this.searchForm.patchValue({ keyword });
    this.onNavigateResults();
  }

  public async onNavigateResults(): Promise<void> {
    try {

      this.shouldDisplay = false;
      const { keyword } = this.searchForm.value;
      if (keyword) {
        await this.router.navigate(['/filtros'], { queryParams: { keyword: this.searchForm.get('keyword')?.value, search: true } });
        if (isPlatformBrowser(this.platformId)) {
          const uuid = uuidv4();
          fbq('track', 'Search', {
            content_type: keyword,
          }, { eventID: uuid });
          this.facebookEvent('Search', uuid, { content_type: 'keyword' });
          //* Pinterest tag
          pintrk('track', 'search', {
            event_id: uuidv4(),
            search_query: keyword
          });
          window.scroll(0, 0);
        }
        this.cleanSearch();
      }
    } catch (error) {
      if (navigator.onLine) {
        location.reload();
      } else {
        this.snackbarService.openSnackbar('Verifica tu red e inténtalo de nuevo.', 'warn');
      }

    }
  }

  private facebookEvent(eventName: string, uuid: string, customData: EventCustomData) {
    try {
      const pixelEvent: PixelEvent = {
        data: {
          event_name: eventName,
          event_time: Date.now(),
          action_source: 'website',
          event_id: uuid,
          user_data: {
            em: encryptTextSHA256(this.client?.email) ?? '',
            ph: encryptTextSHA256(this.client?.cellphone) ?? '',
            fbp: document.cookie.match('(^|;)\\s*' + '_fbp' + '\\s*=\\s*([^;]+)')?.pop() || '',
            fbc: document.cookie.match('(^|;)\\s*' + '_fbc' + '\\s*=\\s*([^;]+)')?.pop() || '',
            external_id: encryptTextSHA256(this.client?.user_id.toString()) ?? ''
          },
          custom_data: customData,
        }
      };
      this.marketingService.pixelCall(pixelEvent);

    } catch (error) {
    }
  }

  public addAddressDialog(): void {
    this.dialog.open(AddressAddComponent, {
      width: '500px',
      disableClose: true
    }).afterClosed().subscribe(response => {
      if (response.data) {
        this.getAddresses();
        this.snackbarService.openSnackbar('ADDRESSES.created', 'success');
      }
    });
  }

  public async onSelectingStoreType(type: any): Promise<any> {
    if (this.selectedAddress?.type) {
      this.dialog.open(WarnMissingProductsComponent, {
        width: '400px',
        autoFocus: false
      }).afterClosed().subscribe(async (res: boolean) => {
        if (res) {
          this.selectingStore(type);
        }
      });
    } else {
      this.selectingStore(type);
    }
  }

  public async selectingStore(type: IAlsuperTypes): Promise<void> {
    if (this.address) {
      await this.getNearStores();
      try {
        this.nearStore = null;
        switch (type.filter) {
          case 'fresh_market':
            this.nearStore = this.nearStoresServiceResponse.FRESH_MARKET;
            break;
          case 'alsuper':
            this.nearStore = this.nearStoresServiceResponse.ALSUPER;
            break;
          case 'alsuper_plus':
            this.nearStore = this.nearStoresServiceResponse.ALSUPER_PLUS;
            break;
        }
        if (this.nearStore !== null) {
          await this.addressService.setAsDefault(this.address.id);
          const addressJSON = {
            type: 'delivery',
            displayName: `${this.address.detail} ${this.address.number}`,
            store: this.nearStore.branch,
            storeType: type.filter,
            meters: this.nearStore.distance
          };
          this.selectedAddress = addressJSON;
          if (this.isBrowser) localStorage.setItem('address', JSON.stringify(addressJSON));
          await this.cartService.onSettingDeliveryAddress({
            branch_id: this.nearStore.branch,
            client_address: this.address.id
          });
          this.toValidateToken();
          //this.observerInit();
          this.ordersService.refreshHome$.emit(true);
          this.productService.productRefresh$.emit(true);
        } else {
          this.dialog.open(NotNearStoresModalComponent, {
            width: '400px',
            autoFocus: false
          }).afterClosed().subscribe((res: boolean) => {
            if (res) {
              this.deliveryMenuTrigger.openMenu();
            }
          });
        }
      } catch (error) {
      }
    }
  }

  @HostListener('window:scroll', ['$event'])
  public onScroll(): void {
    if (this.isBrowser) {
      const verticalOffset = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (verticalOffset >= 1) {
        this.deleteSpaceTop = true;
      } else if (verticalOffset <= 1) {
        this.deleteSpaceTop = false;
      }
    }
  }

  public openCpSelect(): void {
    this.dialog.open(CpInviteModeModalComponent, {
      autoFocus: false,
      minWidth: '360px'
    }).afterClosed().subscribe((response: { status: boolean, pickup: boolean }) => {
      if (response?.status) {
        if (response.pickup) {
          //;
          this.ordersService.refreshHome$.emit(true);
          this.productService.productRefresh$.emit(true);
        }
      }
    });
  }

  public openMobileMenu(): void {
    this.dialog.open(MobileMenuModalComponent, {
      autoFocus: false,
      position: { top: 'top' },
      panelClass: ['animate__animated', 'animate__slideInUp', 'as-mobile-menu-modal'],
      width: '100vw',
      minHeight: '100vh',
      data: { departments: this.departments, user: this.user }
    }).afterClosed().subscribe(({
      next: async (response: string) => {
        if (response === 'signout') {
          if (isPlatformBrowser(this.platformId)) {
            this.store.dispatch(cart.unSetCart());
            this.storeUser.dispatch(user.unSetUser());
            localStorage.clear();
          }
          await this.authService.signout();
          this.tokenService.signOut();
          await this.router.navigate(['']);
          this.toValidateToken();
          //  this.observerInit();
          this.totalItems = 0;
          this.totalAmount = 0;
          this.user = null;
          this.ordersService.refreshHome$.emit(true);
        }
      }
    }));
  }
}
